"use client";

import { useState } from "react";

export default function FaqAccordion({
  faqs,
  variant = "pricing",
  defaultOpenIndex = 0,
}) {
  const [openIdx, setOpenIdx] = useState(defaultOpenIndex);

  if (!faqs?.length) return null;

  const toggle = (idx) => {
    setOpenIdx((prev) => (prev === idx ? -1 : idx));
  };

  if (variant === "home") {
    return (
      <div className="flex flex-col">
        {faqs.map((faq, idx) => {
          const isOpen = idx === openIdx;

          return (
            <div
              key={faq.id ?? idx}
              className="border-b  border-zinc-100 py-2.5 lg:py-2"
            >
              <button
                onClick={() => toggle(idx)}
                className={`w-full flex items-center justify-between gap-2 text-left transition-colors ${
                  isOpen
                    ? "text-[#242424]"
                    : "text-[#242424] hover:text-[#2D2D97]"
                }`}
              >
                <span className=" text-[14px] lg:text-[16px] font-[500] ">
                  {faq.question}
                </span>
                <span className="text-lg lg:text-2xl shrink-0 leading-none">
                  {isOpen ? "−" : "+"}
                </span>
              </button>

              {isOpen && (
                <p className="mt-1.5 text-zinc-500  text-[14px] lg:text-sm leading-relaxed max-w-[560px]">
                  {faq.answer}
                </p>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center gap-6">
      {faqs.map((faq, index) => {
        const isOpen = index === openIdx;

        return (
          <div
            key={faq.id ?? index}
            className="md:w-full sm:w-[70%] w-full transition-all duration-300"
          >
            <div className="faq-item w-full">
              <button
                onClick={() => toggle(index)}
                className="w-full flex justify-between items-center text-left font-medium text-lg text-gray-800 bg-white shadow p-[25px] rounded-2xl hover:shadow-lg transition-shadow duration-300"
              >
                <span>{faq.question}</span>

                <span className="text-[#283245] text-[27px] w-[38px] h-[38px] flex items-center justify-center rounded-[8px] bg-[#9573F71A]">
                  {isOpen ? "−" : "+"}
                </span>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 bg-white shadow rounded-2xl ${
                  isOpen
                    ? "max-h-[500px] my-3 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="p-[25px] pr-12 text-[16px] leading-[24px] opacity-[80%]">
                  {faq.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
